// Convert Persian number to English
export function toEnglishNumber(persianStr: string) {
  // Create a mapping of Persian to English numerals
  const persianToEnglishMap: any = {
    "۰": "0", // Persian digit 0
    "۱": "1", // Persian digit 1
    "۲": "2", // Persian digit 2
    "۳": "3", // Persian digit 3
    "۴": "4", // Persian digit 4
    "۵": "5", // Persian digit 5
    "۶": "6", // Persian digit 6
    "۷": "7", // Persian digit 7
    "۸": "8", // Persian digit 8
    "۹": "9", // Persian digit 9
  };

  // Convert the Persian string to English numerals
  let englishStr = "";
  for (let i = 0; i < persianStr.length; i++) {
    const char = persianStr[i];
    // If the character is a Persian numeral, convert it using the map
    if (persianToEnglishMap.hasOwnProperty(char)) {
      englishStr += persianToEnglishMap[char];
    } else {
      // Otherwise, keep the character as it is
      englishStr += char;
    }
  }

  return englishStr;
}
export function convertToFa(value: number) {
  if (value) {
    const converted = new Intl.NumberFormat("FA-IR").format(value);
    return converted;
  }
}
export const setMetaOgHead = function (content: string, image = "") {
  document.title = content;
  const metaIg = ["og:description", "og:site_name", "og:title"];
  metaIg.forEach((item) => {
    const ogTitle = document.createElement("meta");
    ogTitle.setAttribute("property", item);
    ogTitle.content = content;
    document.getElementsByTagName("head")[0].append(ogTitle);
  });
  const ogTitle = document.createElement("meta");
  ogTitle.setAttribute("property", "og:image");
  ogTitle.content = image;
  document.getElementsByTagName("head")[0].append(ogTitle);
};
